// config4js.js - environment-aware backend config (ZKMS-398 / CSTEM-6.5.3)
const ziroProdUrl = 'https://zirostudio.appspot.com';
const ziroTestUrl = 'https://zirostudio-test.uc.r.appspot.com'; // Test environment
const ziroDevUrl  = 'https://ziroaidev.appspot.com';
const ziro78StagingUrl = 'https://ziro-ai-staging.uc.r.appspot.com'; // 7.8 backend (App Engine)
const ziro78AuthUrl = 'https://auth-dot-ziro-ai-staging.uc.r.appspot.com'; // 7.8 auth service

const prodClientID = '37170801728-5e3di89a5pp1v0rg102a64l0a4so22nu.apps.googleusercontent.com';
const devClientID  = '1050770307315-6s4be5midit1kgft5clv237nkpukoc24.apps.googleusercontent.com';

// Detect test/local environment — routes to zirostudio-test backend to avoid CORS
const _isTestEnv = (
    window.location.hostname === 'test.ziro.studio' ||
    window.location.hostname === 'zirostudio-test.web.app' ||
    window.location.hostname.includes('zirostudio-test') ||
    window.location.hostname === 'localhost'
);

export const serverUrl        = _isTestEnv ? ziroTestUrl : ziroProdUrl;
export const altServerUrl     = ziroDevUrl;   // Auth service (ziroaidev) — shared for now
export const globalClientId   = prodClientID;
export const exploreBackendUrl = _isTestEnv ? ziroTestUrl : ziroProdUrl;